import { useAtomValue } from "jotai";
import { useMemo } from "react";
import { LuLoader } from "react-icons/lu";

import { P } from "@sorcery/ui";
import { deckbuildingRuleViolations } from "@sorcery/utils/universal/deck";

import { DeckCardCount } from "~/components/molecules/deck/DeckCardCount";
import { Stats } from "~/components/molecules/deck/Stats";
import { deckJotai, decklistJotai, sideboardJotai } from "~/state/deckJotai";
import { Decklist } from "./Decklist";

export const CompanionDecklist = () => {
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  const deck = useAtomValue(deckJotai)!;
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  const decklist = useAtomValue(decklistJotai)!;
  // biome-ignore lint/style/noNonNullAssertion: <explanation>
  const sideboard = useAtomValue(sideboardJotai)!;
  const ruleInfringements = useMemo(
    () =>
      deckbuildingRuleViolations.filter(
        (r) =>
          deck.format === r.format &&
          r.check({
            decklist,
            sideboard,
          }),
      ),
    [decklist, sideboard, deck.format],
  );

  return (
    <div className="ml-5 hidden border-l border-line-color pl-5 md:block">
      <div className="sticky top-1 mb-7 max-h-[97vh] overflow-y-auto overflow-x-hidden">
        {/*  magic numbers, dont touch */}
        <div className="mb-5 mr-4 md:w-[310px] xl:w-[400px]">
          <Decklist size={"sm"} />

          {!!ruleInfringements.length && (
            <div className="text-bold border-t border-t-line-color py-5" role="alert">
              <P className="!mb-2 font-bold">
                {" "}
                <LuLoader size={11} className="-mt-[3px] mr-1 inline" />
                <span>&nbsp;Work in progress</span>
              </P>

              {ruleInfringements.map((r) => (
                <div key={r.name}>
                  <P className="!mb-0 italic">
                    <span>-&nbsp;</span>
                    {r.name}
                    {!!r.context && (
                      <em>
                        :{" "}
                        {r.context({
                          decklist,
                          sideboard,
                        })}
                      </em>
                    )}
                  </P>
                </div>
              ))}
            </div>
          )}

          <div className="border-t border-t-line-color py-5">
            <DeckCardCount />
          </div>
          <div className="border-t border-line-color py-5">
            <Stats size="sm" />
          </div>
        </div>
      </div>
    </div>
  );
};
